import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

export const useDeleteWebhook = () => {
  const queryClient = useQueryClient();

  const deleteGroup = async (
    customerId: number,
    webhookId: number
  ): Promise<void> => {
    await Axios.delete(
      `${DELETE_URL(customerId.toString(), webhookId.toString()).webhook}`
    );
  };

  return useMutation<
    void,
    AxiosError<BaseError>,
    { customerId: number; webhookId: number }
  >(({ customerId, webhookId }) => deleteGroup(customerId, webhookId), {
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries(['customerWebhooks', customerId]);
    },
    useErrorBoundary: false
  });
};
